const OffersTab = ({ offers, setShowOfferModal, darkMode }) => {
  const getStatusConfig = (status) => {
    const configs = {
      'approved': { 
        label: 'Aprovada', 
        color: darkMode ? 'bg-emerald-900/30 border-emerald-700' : 'bg-emerald-50 border-emerald-200', 
        badge: 'bg-emerald-500 text-white' 
      },
      'rejected': { 
        label: 'Rejeitada', 
        color: darkMode ? 'bg-red-900/30 border-red-700' : 'bg-red-50 border-red-200', 
        badge: 'bg-red-500 text-white' 
      },
      'auto_rejected': { 
        label: 'Rejeitada Auto.', 
        color: darkMode ? 'bg-red-900/30 border-red-700' : 'bg-red-50 border-red-200', 
        badge: 'bg-red-600 text-white' 
      },
      'pending': { 
        label: 'Pendente', 
        color: darkMode ? 'bg-amber-900/30 border-amber-700' : 'bg-amber-50 border-amber-200', 
        badge: 'bg-amber-500 text-white' 
      },
      'pending_approval': { 
        label: 'Aguarda Aprovação', 
        color: darkMode ? 'bg-amber-900/30 border-amber-700' : 'bg-amber-50 border-amber-200', 
        badge: 'bg-amber-500 text-white' 
      }
    };
    return configs[status] || { 
      label: status, 
      color: darkMode ? 'bg-slate-700/50 border-slate-600' : 'bg-slate-100 border-slate-200', 
      badge: 'bg-slate-500 text-white' 
    };
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Declaração de Ofertas</h3>
          <p className={`text-sm mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Declare ofertas recebidas ou oferecidas a terceiros</p>
        </div>
        <button
          onClick={() => setShowOfferModal(true)}
          className="px-4 py-2 rounded-lg bg-amber-600 text-white text-sm hover:bg-amber-500 transition-colors flex items-center gap-2"
          data-testid="declare-offer-btn"
        >
          🎁 Declarar Oferta
        </button>
      </div>

      {/* Info Card */}
      <div className={`mb-6 p-4 rounded-lg border ${darkMode ? 'bg-blue-900/30 border-blue-700' : 'bg-blue-50 border-blue-200'}`}>
        <h4 className={`font-medium mb-2 ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>ℹ️ Política de Ofertas (RGPC)</h4>
        <p className={`text-sm ${darkMode ? 'text-slate-300' : 'text-slate-600'}`}>
          De acordo com a política de compliance da empresa, todas as ofertas devem ser declaradas.
          Ofertas acima do limite definido necessitam de aprovação prévia.
        </p>
      </div>

      {/* Offers List */}
      {offers.length === 0 ? (
        <div className="text-center py-12">
          <span className="text-5xl block mb-4">🎁</span>
          <p className={`mb-2 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem ofertas declaradas</p>
          <button
            onClick={() => setShowOfferModal(true)}
            className="px-4 py-2 rounded-lg bg-amber-600 text-white hover:bg-amber-500"
          >
            Declarar Primeira Oferta
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {offers.map((offer, idx) => {
            const status = getStatusConfig(offer.status);
            const offerValue = offer.estimated_value || offer.value || 0;
            
            return (
              <div key={offer.offer_id || idx} className={`p-4 rounded-lg border ${status.color}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xl">{offer.direction === 'received' ? '📥' : '📤'}</span>
                      <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{offer.description || offer.offer_type}</p>
                      <span className={`px-2 py-0.5 rounded text-xs font-medium ${status.badge}`}>
                        {status.label}
                      </span>
                    </div>
                    
                    <div className="grid md:grid-cols-2 gap-2 mb-2">
                      <div>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Entidade:</span> {offer.related_entity_name || offer.offered_by || '-'}
                        </p>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Tipo:</span> {offer.related_entity_type || offer.offered_by_type || '-'}
                        </p>
                      </div>
                      <div>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Data:</span> {offer.offer_date || offer.created_at?.split('T')[0] || '-'}
                        </p>
                        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                          <span className="font-medium">Direção:</span> {offer.direction === 'received' ? 'Recebida' : 'Oferecida'}
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-4">
                      <p className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>{offerValue?.toFixed(2)} €</p>
                    </div>
                    
                    {offer.approval_justification && (
                      <p className={`text-sm mt-2 italic ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                        Justificação: {offer.approval_justification}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OffersTab;
